import script from "./SectionInformativeGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionInformativeGrid.vue?vue&type=script&setup=true&lang=js"

import "./SectionInformativeGrid.vue?vue&type=style&index=0&id=e11792f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e11792f2"]])

export default __exports__